<template>
  <div id="app" v-title data-title="e学e驾官网-轻松学车,安全驾驶">
    <div id="nav">
    <router-view v-if="isRouterAlive"></router-view>
    </div>
   
  </div>
</template>
<script>
    export default {
        data() {
            return {
                lnglat: "",
                isRouterAlive: true
            };
        },
        provide() {
            return {
                reload: this.reload
            }
        },
        created() {
            //在页面加载时读取sessionStorage里的状态信息
            if (sessionStorage.getItem("store")) {
                this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
            }
            //在页面刷新时将vuex里的信息保存到sessionStorage里
            window.addEventListener("beforeunload", () => {
                sessionStorage.setItem("store", JSON.stringify(this.$store.state))
            })
        },
        　mounted() {
            window.addEventListener('unload', this.saveState)
        },
        methods: {
            saveState() {
                sessionStorage.setItem('state', JSON.stringify(this.$store.state))
            },
            reload() {
                this.isRouterAlive = false
                this.$nextTick(function() {
                    this.isRouterAlive = true
                })
            }
        }

    }
</script>
<style>
    /*引入公共样式*/
    
    @import '../public/css/style.css';
</style>